<template>
  <div></div>
</template>

<script>
export default {
    name: 'empRedirect',
    props: ['user'],
    
    beforeMount() {
    let token = this.$route.query.token;
    let redirectRoute = "/recruit/client-job-dashboard";
    if(this.$cookies.get("hire-employer")) {
      this.$cookies.remove("hire-employer");
    }
    new this.$apiAction().getEmployer(token).then(async resp => {
      if (resp.data) {
         const employer_token = {token: this.$route.query.token, name: resp.data.client_users.contact_person_name}
         this.$cookies.set("hire-employer", employer_token);
         await this.$router.push(redirectRoute);
         location.reload();
      } else { 
        this.$router.replace("/").catch(() => {});
      }
    }).catch((err) => {
      this.$cookies.remove("hire-employer");
      if (err) {
        this.$router.replace("/recruit").catch(() => {});
      }
    });
  }
}
</script>
